var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTelegramMobile = function SvgIconTelegramMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M17.258 3.045s1.619-.631 1.483.902c-.044.631-.449 2.84-.764 5.23l-1.08 7.08s-.09 1.037-.899 1.217c-.809.18-2.023-.631-2.248-.812-.18-.135-3.373-2.164-4.497-3.156-.315-.27-.675-.812.045-1.443l4.722-4.509c.54-.54 1.079-1.803-1.17-.27l-6.295 4.283s-.72.451-2.069.045l-2.923-.902s-1.08-.676.764-1.352c4.498-2.12 10.029-4.284 14.93-6.313Z"
  })));
};
export default SvgIconTelegramMobile;